import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import { Checkbox } from 'redux-form-material-ui';

function clickTOS() {
  document.getElementsByName('tos')[0].click();
}

const TermsOfServiceField = props => (
  <Field
    name="tos"
    component={ Checkbox }
    className={ props.className }
    validate={ props.validate }
    labelStyle={{ zIndex: 3 }}
    label= {
      <div>
        <span onClick={ clickTOS }>I confirm that I have read and agree to iFit&#39;s{' '}</span>
        <span className={ 'go-to-tos' } onClick={ props.tosClick }>Terms of Use</span>
        <span onClick={ clickTOS }>{' '}and{' '}</span>
        <span className={ 'go-to-privacy' } onClick={ props.privacyClick }>Privacy Policy</span>.
      </div>
    }
  />
);

TermsOfServiceField.propTypes = {
  validate: PropTypes.func,
  className: PropTypes.string,
  tosClick: PropTypes.func,
  privacyClick: PropTypes.func
};

export default TermsOfServiceField;